export default "__VITE_ASSET__381a3455__"